<template src="./template.html"></template>

<script>
import { i18n } from '@/translations/i18n'
import { mapState } from 'vuex'

export default {
  name: 'NavLink',
  props: {
    'route': String,
    'label': {
      type: String,
      required: true,
    },
    'id': {
      type: String,
      required: true,
    },
    'classes': {
      type: Array,
      default: () => [],
    },
    'type': String,
  },
  computed: {
    ...mapState('auth', [ 'auth_status' ]),
    locale() {
      return i18n.locale.replace(/-/g, '_')
    },
    modalAttribute() {
      return this.id === 'auth' ? { key: 'data-modal', value: !this.auth_status.isAuthenticated } : {}
    },
    activeClass() {
      return { on: window.pathname === this.route || window.location.pathname === this.route }
    },
  },
  mounted() {
    this.modalLinks()
  },
  updated() {
    this.modalLinks()
  },
  methods: {
    modalLinks() {
      const link = this.$refs.link
      window.jQuery(link).unbind('click.modalNavigation')
      if (link.hasAttribute('data-modal')) {
        window.jQuery(link).modalNavigation()
        window.jQuery(link).on('click', function(e) {
          e.preventDefault()
        })
      }
    },
  },
}
</script>
